import { Box, Heading } from '@chakra-ui/react';
import { IStyleGuide } from 'interfaces/style-guide.interface';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

type StyleGuideItemProps = {
  data: IStyleGuide;
};

function StyleGuideItem({ data }: StyleGuideItemProps) {
  return (
    <Box>
      <Link href={`/style-guide/${data.permalink}`}>
        <Box mb={3}>
          <Image
            src={`${process.env.NEXT_PUBLIC_FILE_URL}/${data.featuredImage?.name}`}
            alt={data.title}
            width={400}
            height={400}
          ></Image>
        </Box>
        <Box textAlign="left">
          <Heading as="h6" fontSize="md">
            {data.title}
          </Heading>
        </Box>
      </Link>
    </Box>
  );
}

export default StyleGuideItem;
